import { useMutation } from '@tanstack/react-query';

import { EnableIsHotDialogNotificationData, PLATFORM_URL_SEGMENT } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const disableIsHotDialogNotification = (
  data: EnableIsHotDialogNotificationData
): Promise<void> => {
  return axios.post(
    `/${PLATFORM_URL_SEGMENT[data.platform]}/pages/disable-hot-dialog-notification`,
    data
  );
};

type DisableIsHotDialogNotificationOptions = {
  config?: MutationConfig<typeof disableIsHotDialogNotification>;
};

export function useDisableIsHotDialogNotification({
  config,
}: DisableIsHotDialogNotificationOptions = {}) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['pages']);
    },
    ...config,
    mutationFn: disableIsHotDialogNotification,
  });
}
